import { computed, ComputedRef, useRoute } from '@nuxtjs/composition-api';
import useBrandConfig from '@shared/composables/useBrandConfig';
import { ProductViewModel } from '@shared/types/ProductViewModel';
import { Product, productGetters, useProduct } from '@unified-commerce/gpc-vue-storefront-shopify';

import useFeatureFlag from '../useFeatureFlag';
import { toProductViewModel } from './toProductViewModel';

// * this interface is copied from vue-storefront
interface ProductsSearchParams {
  perPage?: number;
  page?: number;
  sort?: any;
  term?: any;
  filters?: any;
}

interface Error {
  name: string;
  message: string;
  stack?: string;
}

interface UseShopifyProduct {
  fetchProduct: (params: ProductsSearchParams) => Promise<void>;
  loading: ComputedRef<boolean>;
  error: ComputedRef<Error | undefined>;
  product: ProductViewModel;
  tempRawProduct: ComputedRef<Product>;
}

const useShopifyProduct = (): UseShopifyProduct => {
  const route = useRoute();
  const { globalConfig } = useBrandConfig();
  const { slug } = route.value.params;
  const { products, loading, error, search } = useProduct(slug);
  const { featureFlagEnabled } = useFeatureFlag();

  const product = computed(() => productGetters.getFiltered(products.value)[0]);

  const fetchProduct = (params?: ProductsSearchParams): Promise<void> => {
    return search({
      slug,
      ...params,
    });
  };

  return {
    fetchProduct,
    loading: computed(() => loading.value),
    error: computed(() => error.value?.search),
    product: toProductViewModel(product, globalConfig, featureFlagEnabled),
    tempRawProduct: product,
  };
};

export default useShopifyProduct;
